jQuery(document).ready(function ($) {
  //HEADER//
  function onScroll() {
    var scroll = $(window).scrollTop();
    if (scroll >= 5) {
      $(".section-header").addClass("darkHeader");
      $(".section-header").addClass("active_header");
    } else {
      $(".section-header").removeClass("darkHeader");
      $(".section-header").removeClass("active_header");
    }
  }
  onScroll();
  $(window).on("scroll", function () {
    onScroll();
  });

  //desktop - searchbar
  $(".field__input").on("focus", function () {
    $(this).closest(".field").addClass("active_field");
  });

  $(".field__input").on("blur", function () {
    $(this).closest(".field").removeClass("active_field");
  });
  //desktop - searchbar

  ///////////////// DROPDOWN MENU /////////////////
  //dropdown meag menus
  //   $(".mega-menu").attr("open", "true");
  $(".mega-menu").click(function (e) {
    e.preventDefault();
    // $(".mega-menu").attr("open", "true");
    $(this).attr("open", "true");
    if ($(this).hasClass("expand")) {
      $(this).removeClass("expand");
      $("header").removeClass("header_overlay_2");
      $(this).removeAttr("open");
    } else {
      $(".mega-menu").removeClass("expand");
      $(this).addClass("expand");
      $("header").addClass("header_overlay_2");
    }
    //making anchor links inside the dropdown menu clickable which
    //is beng prevented by prevent default
    $(this)
      .find("a")
      .on("click touchend", function (e) {
        var el = $(this);
        var link = el.attr("href");
        window.location = link;
      });
    // // Preventing the event from bubbling up to document
    // e.stopPropagation();
  });
  $(document).click(function (e) {
    if (!$(e.target).closest(".expand").length) {
      // Check if the clicked element is not a descendant of an element with the class .expand
      //   $(".expand").attr("open", "true");
      $(".mega-menu").removeClass("expand");
      $("header").removeClass("header_overlay_2");
    }
  });
  // Contextmenu event for document
  $(document).on("contextmenu", function (e) {
    // Prevent the default context menu behavior
    // e.preventDefault();
    // Allow the default context menu behavior
    setTimeout(function () {
      // Check if the clicked element is not a descendant of an element with the class .expand
      if (!$(e.target).closest(".expand").length) {
        $(".expand").attr("open", "true");
        $(".mega-menu").removeClass("expand");
        $("header").removeClass("header_overlay_2");
      }
    }, 10);
  });

  ///////////////// DROPDOWN MENU /////////////////
  ///////////////// first level dropdown MENU /////////////////
  $("#custom_main_head_block .list-menu__item--active").each(function () {
    $(this)
      .closest("details")
      .find("summary")
      .first()
      .addClass("active_summary");
  });
  $("#custom_main_head_block .menu-drawer__menu-item--active").each(
    function () {
      $(this)
        .closest("details")
        .find("summary")
        .first()
        .addClass("active_summary");
    }
  );

  ///////////////// first level dropdown MENU /////////////////
  //HEADER//

  //////////////  CODE FOR SHOPIFY FORMS APP STYLING  //////////////

  /// FOOTER FORM STYLING ///
  const formContainerFooter = document.querySelector(".footer .form");

  if (formContainerFooter) {
    const observer = new MutationObserver((mutationsList, observer) => {
      const form = formContainerFooter.querySelector("shopify-forms-embed");

      if (form) {
        observer.disconnect(); // Stop observing once the form is found
        const shadow = form.shadowRoot;

        const sheet = new CSSStyleSheet();

        //hiding form heading
        sheet.insertRule(`
                    ._formHeader_cit2d_24{
                        display: none !important;
                    }            
                `);

        //form-wrapper styling
        sheet.insertRule(`
                    ._formContainer_1q1d2_30{
                        margin: 0 !important;
                        min-width: 100% !important;
                    }            
                `);

        //hiding labels
        sheet.insertRule(`
                    label {
                    display: none !important;
                    }
                `);

        // form width
        sheet.insertRule(`            
                    ._container_3eyaa_70 {
                        display: block !important;
                    }            
                `);

        //removing bottom padding from form outter element
        sheet.insertRule(`          
                ._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {
                    padding-bottom: 0 !important;
                }
                `);

        //main form body
        sheet.insertRule(`          
                form {
                    display: grid !important;
                    grid-template-columns: 1fr 1fr !important; /* Two equal columns */
                    grid-template-rows: auto !important; /* Automatically adjust row height */
                }
                `);

        if (window.innerWidth <= 470) {
          sheet.insertRule(`
                        form{
                            gap: 14px !important;
                            grid-template-areas: "first-name first-name"
                                "last-name last-name"
                                "email email"
                                "submit submit" !important;
                        }            
                    `);
        } else {
          sheet.insertRule(`
                        form{
                            gap: 18px !important;
                            grid-template-areas: "first-name last-name"
                                "email email"
                                "submit submit" !important;
                        }            
                    `);
        }
        sheet.insertRule(`
                form > div:nth-child(1) {
                    grid-area: first-name !important; /* First input field */
                }
                `);
        sheet.insertRule(`          
                form > div:nth-child(2) {
                    grid-area: last-name !important; /* Second input field */
                }
                `);
        sheet.insertRule(`          
                form > div:nth-child(3) {
                    grid-area: email !important; /* Second input field */
                }
                `);
        sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                    grid-area: submit !important; /* Submit button */
                }
                `);
        //main form body

        //input and textarea styling
        sheet.insertRule(`
                    input, textarea {
                        border-radius: 0px !important;
                        font-family: stolzl, sans-serif !important;
                        font-weight: 300 !important;
                        font-style: normal !important;
                        color: white !important; 
                        border: 1px solid #a0a2b5 !important; 
                        box-shadow: none !important;
                        border-radius: 5px !important;
                        background: #030F46 !important;
                    }
                `);

        sheet.insertRule(`
                    input::placeholder, textarea::placeholder, .business-need-text {
                        font-family: stolzl, sans-serif !important;
                        font-weight: 300 !important;
                        font-style: normal !important;
                        text-transform: capitalize !important;
                        color: white !important; 
                        opacity: .75 !important;
                    }
                `);

        if (window.innerWidth <= 470) {
          sheet.insertRule(`
                input, textarea {
                    font-size: 11.5px !important;
                    padding: 12px 22px !important;
                }
            `);
          sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 11.5px !important;
                }
            `);
        } else if (window.innerWidth <= 770) {
          sheet.insertRule(`
                input, textarea {
                    font-size: 12px !important;
                    padding: 12px 22px !important;
                }
            `);
          sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 12px !important;
                }
            `);
        } else if (window.innerWidth <= 1410) {
          sheet.insertRule(`
                input, textarea {
                    font-size: 12.5px !important;
                    padding: 12px 23px !important;
                }
            `);
          sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 12.5px !important;
                }
            `);
        } else if (window.innerWidth <= 1920) {
          sheet.insertRule(`
                input, textarea {
                    font-size: 13.5px !important;
                    padding: 12px 23px !important;
                }
            `);
          sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 13.5px !important;
                }
            `);
        } else {
          sheet.insertRule(`
                input, textarea {
                    font-size: 15px !important;
                    padding: 12.75px 25px !important;
                }
            `);
          sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 15px !important;
                }
            `);
        }
        //input and textarea styling

        //submit button styling
        sheet.insertRule(`
            button._formSubmitButton_cit2d_96 {
                background: #ED1C24 !important;
                font-family: stolzl, sans-serif !important;
                font-weight: 300 !important;
                font-style: normal !important;
                color: white !important;
                filter: unset !important;
                transition: all 0.2s ease-in-out 0.01s !important;
            }
        `);
        if (window.innerWidth <= 470) {
          sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                    font-size: 11.5px !important;
                    padding: 13px !important;
                }
            `);
        } else if (window.innerWidth <= 770) {
          sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                    font-size: 12px !important;
                    padding: 13px !important;
                }
            `);
        } else if (window.innerWidth <= 1410) {
          sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                    font-size: 12.5px !important;
                    padding: 14px !important;
                }
            `);
        } else if (window.innerWidth <= 1920) {
          sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                font-size: 13.5px !important;
                padding: 14.5px !important;
                }
            `);
        } else {
          sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                font-size: 15px !important;
                }
            `);
        }
        sheet.insertRule(`
                    button._formSubmitButton_cit2d_96:hover {
                        background: white !important;
                        color: #030F46 !important;
                    }
                `);
        sheet.insertRule(`
                    button._formSubmitButton_cit2d_96::after {
                        content: '';
                        display: inline-block;
                        width: 7px;
                        height: auto;
                        margin-left: 14px;
                        margin-top: .7px;
                        transition: all 0.2s ease-in-out 0.01s !important;
                        background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.04613 0.000234565L4.31523 3.50023L1.04613 6.99023L0.214844 6.10023L2.65266 3.49023L0.214844 0.890234L1.04613 0.000234565Z" fill="white"/></svg>') no-repeat center center;
                        background-size: contain;
                        vertical-align: middle;
                    }
                `);
        sheet.insertRule(`
                    button._formSubmitButton_cit2d_96:hover::after {
                        margin-left: 7px;
                        width: 4.5px;
                        background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.04613 0.000234565L4.31523 3.50023L1.04613 6.99023L0.214844 6.10023L2.65266 3.49023L0.214844 0.890234L1.04613 0.000234565Z" fill="%23030F46"/></svg>') no-repeat center center;
                    }
                `);
        //submit button styling

        //form disclaimer
        sheet.insertRule(`
            ._formDisclaimer_cit2d_38 p {
                color: #F2F3F6 !important;
                opacity: .75 !important;
                font-family: stolzl, sans-serif !important;
                font-weight: 300 !important;
                font-style: normal !important;
                text-transform: capitalize !important;
            }
        `);
        if (window.innerWidth <= 470) {
          sheet.insertRule(`
                ._formDisclaimer_cit2d_38 p {
                    font-size: 10px !important;
                }
            `);
        } else if (window.innerWidth <= 1280) {
          sheet.insertRule(`
                ._formDisclaimer_cit2d_38 p {
                    font-size: 11px !important;
                }
            `);
        } else {
          sheet.insertRule(`
                ._formDisclaimer_cit2d_38 p {
                    font-size: 12px !important;
                }
            `);
        }
        sheet.insertRule(`
                    ._formDisclaimer_cit2d_38 p a{
                        color: #F2F3F6 !important;
                        font-weight: 300 !important;
                        text-decoration-thickness: .5px !important;
                        text-underline-offset: 2px !important;
                        transition: all 0.2s ease-in-out 0.01s !important;
                    }
                `);
        sheet.insertRule(`
                    ._formDisclaimer_cit2d_38 p a:hover{
                        color: #ED1C24 !important;
                    }
                `);
        //form disclaimer


        //form success
        sheet.insertRule(`
            section[data-testid="banner-success"] h2,
            section[data-testid="banner-success"] p{
                display: block !important;
                color: white !important;
                text-align: left !important;
            }
        `);
        //form success

        // Add placeholders to inputs
        const inputs = shadow.querySelectorAll("input, textarea");
        inputs.forEach((input) => {
          switch (input.id) {
            case "first_name":
              input.placeholder = "first name";
              break;
            case "last_name":
              input.placeholder = "last name";
              break;
            case "email":
              input.placeholder = "email address";
              break;
            default:
              break;
          }
        });

        // Apply the styles to the Shadow DOM
        shadow.adoptedStyleSheets.push(sheet);
        // Add a class to the form container for further customization
        formContainerFooter.classList.add("loaded");
      }
    });

    // Observe for changes only within the custom section
    observer.observe(formContainerFooter, { childList: true, subtree: true });

    // Resize event listener to act like media query
    window.addEventListener("resize", () => {
      // Trigger MutationObserver actions based on screen size
      observer.takeRecords(); // Forces MutationObserver to re-evaluate
    });
  }
  /// FOOTER FORM STYLING ///

  /// CONTACT PAGE FORM STYLING ///
  if ($("body").hasClass("pg_contact")) {
    const formContainerContactPage = document.querySelector(
      ".contact_page .sec_form_map .form"
    );

    if (formContainerContactPage) {
      const observer = new MutationObserver((mutationsList, observer) => {
        const form = formContainerContactPage.querySelector("shopify-forms-embed");

        if (form) {
          observer.disconnect(); // Stop observing once the form is found
          const shadow = form.shadowRoot;

          const sheet = new CSSStyleSheet();

          //hiding form heading
          sheet.insertRule(`
                        ._formHeader_cit2d_24{
                            display: none !important;
                        }            
                    `);

          //form-wrapper styling
          sheet.insertRule(`
                        ._formContainer_1q1d2_30{
                            margin: 0 !important;
                            min-width: 100% !important;
                        }            
                    `);

          //hiding labels
          sheet.insertRule(`
                        label {
                        display: none !important;
                        }
                    `);

          // form width
          sheet.insertRule(`            
                        ._container_3eyaa_70 {
                            display: block !important;
                        }            
                    `);

          //removing bottom padding from form outter element
          sheet.insertRule(`          
                        ._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {
                            padding-bottom: 0 !important;
                        }
                    `);

          //main form body
          sheet.insertRule(`          
                        form {
                            display: grid !important;
                            grid-template-columns: 1fr 1fr !important; /* Two equal columns */
                            grid-template-rows: auto !important; /* Automatically adjust row height */
                        }
                    `);

          if (window.innerWidth <= 550) {
            sheet.insertRule(`
                          form{
                              gap: 14px !important;
                              grid-template-areas: "first-name first-name"
                                  "last-name last-name"
                                  "email email"
                                  "msg msg"
                                  "submit submit" !important;
                          }            
                      `);
          } else if (window.innerWidth <= 770) {
            sheet.insertRule(`
                form{
                    gap: 18px !important;
                    grid-template-areas: "first-name last-name"
                        "email email"
                        "msg msg"
                        "submit submit" !important;
                }           
            `);
          } else if (window.innerWidth <= 989) {
            sheet.insertRule(`
                form{
                    gap: 14px !important;
                    grid-template-areas: "first-name first-name"
                        "last-name last-name"
                        "email email"
                        "msg msg"
                        "submit submit" !important;
                }            
            `);
          } else {
            sheet.insertRule(`
                form{
                    gap: 18px !important;
                    grid-template-areas: "first-name last-name"
                        "email email"
                        "msg msg"
                        "submit submit" !important;
                }            
            `);
          }
          sheet.insertRule(`
                        form > div:nth-child(1) {
                            grid-area: first-name !important; /* First input field */
                        }
                    `);
          sheet.insertRule(`          
                        form > div:nth-child(2) {
                            grid-area: last-name !important; /* Second input field */
                        }
                    `);
          sheet.insertRule(`          
                        form > div:nth-child(3) {
                            grid-area: email !important; /* Second input field */
                        }
                    `);
          sheet.insertRule(`          
                        form > div:nth-child(4) {
                            grid-area: msg !important; /* Second input field */
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96 {
                            grid-area: submit !important; /* Submit button */
                        }
                    `);
          //main form body

          //input and textarea styling
          sheet.insertRule(`
                        input, textarea {
                            border-radius: 0px !important;
                            font-family: stolzl, sans-serif !important;
                            font-weight: 300 !important;
                            font-style: normal !important;
                            color: #8187A2 !important; 
                            border: 2px solid #e9eaec !important; 
                            box-shadow: none !important;
                            border-radius: 5px !important;
                            background: transparent !important;
                        }
                    `);
          sheet.insertRule(`
                        input::placeholder, textarea::placeholder, .business-need-text {
                            font-family: stolzl, sans-serif !important;
                            font-weight: 300 !important;
                            font-style: normal !important;
                            text-transform: capitalize !important;
                            color: #8187A2 !important; 
                            opacity: 1 !important;
                        }
                    `);
          if (window.innerWidth <= 470) {
            sheet.insertRule(`
                input, textarea {
                    font-size: 11.5px !important;
                    padding: 12px 22px !important;
                }
            `);
            sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 11.5px !important;
                }
            `);
          } else if (window.innerWidth <= 770) {
            sheet.insertRule(`
                input, textarea {
                    font-size: 12px !important;
                    padding: 12px 22px !important;
                }
            `);
            sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 12px !important;
                }
            `);
          } else if (window.innerWidth <= 1410) {
            sheet.insertRule(`
                input, textarea {
                    font-size: 12.5px !important;
                    padding: 12px 23px !important;
                }
            `);
            sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 12.5px !important;
                }
            `);
          } else if (window.innerWidth <= 1920) {
            sheet.insertRule(`
                input, textarea {
                    font-size: 13.5px !important;
                    padding: 12px 23px !important;
                }
            `);
            sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 13.5px !important;
                }
            `);
          } else {
            sheet.insertRule(`
                input, textarea {
                    font-size: 15px !important;
                    padding: 12.75px 25px !important;
                }
            `);
            sheet.insertRule(`
                input::placeholder, textarea::placeholder, .business-need-text {
                    font-size: 15px !important;
                }
            `);
          }
          //input and textarea styling

          //submit button styling
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96 {
                            background: #030F46 !important;
                            font-family: stolzl, sans-serif !important;
                            font-weight: 300 !important;
                            font-style: normal !important;
                            color: white !important;
                            filter: unset !important;
                            transition: all 0.2s ease-in-out 0.01s !important;
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96:hover {
                            background: #ED1C24 !important;
                            color: white !important;
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96::after {
                            content: '';
                            display: inline-block;
                            width: 7px;
                            height: auto;
                            margin-left: 14px;
                            margin-top: .7px;
                            transition: all 0.2s ease-in-out 0.01s !important;
                            background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.04613 0.000234565L4.31523 3.50023L1.04613 6.99023L0.214844 6.10023L2.65266 3.49023L0.214844 0.890234L1.04613 0.000234565Z" fill="white"/></svg>') no-repeat center center;
                            background-size: contain;
                            vertical-align: middle;
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96:hover::after {
                            margin-left: 7px;
                            width: 4.5px;
                        }
                    `);
          if (window.innerWidth <= 470) {
            sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                    font-size: 11.5px !important;
                    padding: 13px !important;
                }
            `);
          } else if (window.innerWidth <= 770) {
            sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                    font-size: 12px !important;
                    padding: 13px !important;
                }
            `);
          } else if (window.innerWidth <= 1410) {
            sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                    font-size: 12.5px !important;
                    padding: 14px !important;
                }
            `);
          } else if (window.innerWidth <= 1920) {
            sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                font-size: 13.5px !important;
                padding: 14.5px !important;
                }
            `);
          } else {
            sheet.insertRule(`
                button._formSubmitButton_cit2d_96 {
                font-size: 15px !important;
                }
            `);
          }
          //submit button styling

          //form disclaimer
          sheet.insertRule(`
                        ._formDisclaimer_cit2d_38 p {
                            color: #8187A2 !important;
                            font-family: stolzl, sans-serif !important;
                            font-weight: 300 !important;
                            font-style: normal !important;
                            text-transform: capitalize !important;
                            line-height: 1.65;
                        }
                    `);
          if (window.innerWidth <= 470) {
            sheet.insertRule(`
                ._formDisclaimer_cit2d_38 p {
                    font-size: 10px !important;
                }
            `);
          } else if (window.innerWidth <= 1280) {
            sheet.insertRule(`
                ._formDisclaimer_cit2d_38 p {
                    font-size: 11px !important;
                }
            `);
          } else {
            sheet.insertRule(`
                ._formDisclaimer_cit2d_38 p {
                    font-size: 12px !important;
                }
            `);
          }
          sheet.insertRule(`
                        ._formDisclaimer_cit2d_38 p a{
                            color: #8187A2 !important;
                            font-weight: 300 !important;
                            text-decoration-thickness: .5px !important;
                            text-underline-offset: 2px !important;
                            transition: all 0.2s ease-in-out 0.01s !important;
                        }
                    `);
          sheet.insertRule(`
                        ._formDisclaimer_cit2d_38 p a:hover{
                            color: #ED1C24 !important;
                        }
                    `);
          //form disclaimer

          //form success
          sheet.insertRule(`
              section[data-testid="banner-success"] h2,
              section[data-testid="banner-success"] p{
                  color: #030F46 !important;
              }
          `);
          //form success

          // Add placeholders to inputs
          const inputs = shadow.querySelectorAll("input, textarea");
          inputs.forEach((input) => {
            const identifier = input.id || input.name; // fallback to name if no id
            switch (identifier) {
              case "first_name":
                input.placeholder = "first name*";
                break;
              case "last_name":
                input.placeholder = "last name*";
                break;
              case "email":
                input.placeholder = "email address*";
                break;
              case "custom#message":
                input.placeholder = "message*";
                break;
              default:
                break;
            }
          });

          // Apply the styles to the Shadow DOM
          shadow.adoptedStyleSheets.push(sheet);
          // Add a class to the form container for further customization
          formContainerContactPage.classList.add("loaded");
        }
      });

      // Observe for changes only within the custom section
      observer.observe(formContainerContactPage, {
        childList: true,
        subtree: true,
      });

      // Resize event listener to act like media query
      window.addEventListener("resize", () => {
        // Trigger MutationObserver actions based on screen size
        observer.takeRecords(); // Forces MutationObserver to re-evaluate
      });
    }
  }
  /// CONTACT PAGE FORM STYLING ///

  /// GENERAL FRAMING PAGE FORM STYLING ///
  if (
    $("body").hasClass("temp_name_general-framing") ||
    $("body").hasClass("temp_name_treehugger-framing")
  ) {
    const formContainerContactPage = document.querySelector(
      ".general_framing_page .hero_form_slider .form"
    );

    if (formContainerContactPage) {
      const observer = new MutationObserver((mutationsList, observer) => {
        const form = formContainerContactPage.querySelector("shopify-forms-embed");

        if (form) {
          observer.disconnect(); // Stop observing once the form is found
          const shadow = form.shadowRoot;

          const sheet = new CSSStyleSheet();

          //hiding form heading
          sheet.insertRule(`
                        ._formHeader_cit2d_24{
                            display: none !important;
                        }            
                    `);

          //form-wrapper styling
          sheet.insertRule(`
                        ._formContainer_1q1d2_30{
                            margin: 0 !important;
                            min-width: 100% !important;
                        }            
                    `);

          //hiding labels
          sheet.insertRule(`
                        label {
                        display: none !important;
                        }
                    `);

          // form width
          sheet.insertRule(`            
                        ._container_3eyaa_70 {
                            display: block !important;
                        }            
                    `);

          //removing bottom padding from form outter element
          sheet.insertRule(`          
                        ._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {
                            padding-bottom: 0 !important;
                        }
                    `);

          //main form body
          sheet.insertRule(`          
                        form {
                            display: grid !important;
                            grid-template-columns: 1fr 1fr !important; /* Two equal columns */
                            grid-template-rows: auto !important; /* Automatically adjust row height */
                        }
                    `);
          if (window.innerWidth <= 550) {
            sheet.insertRule(`
                          form{
                              gap: 14px !important;
                              grid-template-areas: "first-name first-name"
                                  "last-name last-name"
                                  "email email"
                                  "msg msg"
                                  "submit submit" !important;
                          }            
                      `);
          } else if (window.innerWidth <= 770) {
            sheet.insertRule(`
                form{
                    gap: 18px !important;
                    grid-template-areas: "first-name last-name"
                        "email email"
                        "msg msg"
                        "submit submit" !important;
                }           
            `);
          } else if (window.innerWidth <= 989) {
            sheet.insertRule(`
                form{
                    gap: 14px !important;
                    grid-template-areas: "first-name first-name"
                        "last-name last-name"
                        "email email"
                        "msg msg"
                        "submit submit" !important;
                }            
            `);
          } else {
            sheet.insertRule(`
                form{
                    gap: 18px !important;
                    grid-template-areas: "first-name last-name"
                        "email email"
                        "msg msg"
                        "submit submit" !important;
                }            
            `);
          }
          sheet.insertRule(`
                        form > div:nth-child(1) {
                            grid-area: first-name !important; /* First input field */
                        }
                    `);
          sheet.insertRule(`          
                        form > div:nth-child(2) {
                            grid-area: last-name !important; /* Second input field */
                        }
                    `);
          sheet.insertRule(`          
                        form > div:nth-child(3) {
                            grid-area: email !important; /* Second input field */
                        }
                    `);
          sheet.insertRule(`          
                        form > div:nth-child(4) {
                            grid-area: msg !important; /* Second input field */
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96 {
                            grid-area: submit !important; /* Submit button */
                        }
                    `);
          //main form body

          //input and textarea styling
          sheet.insertRule(`
                        input, textarea {
                            border-radius: 0px !important;
                            font-family: stolzl, sans-serif !important;
                            font-weight: 300 !important;
                            font-style: normal !important;
                            color: #8187A2 !important; 
                            border: 2px solid #e9eaec !important; 
                            box-shadow: none !important;
                            border-radius: 5px !important;
                            background: transparent !important;
                        }
                    `);
          sheet.insertRule(`
                        input::placeholder, textarea::placeholder, .business-need-text {
                            font-family: stolzl, sans-serif !important;
                            font-weight: 300 !important;
                            font-style: normal !important;
                            text-transform: capitalize !important;
                            color: #8187A2 !important; 
                            opacity: 1 !important;
                        }
                    `);
          if (window.innerWidth <= 470) {
            sheet.insertRule(`
                    input, textarea {
                        font-size: 11.5px !important;
                        padding: 12px 22px !important;
                    }
                `);
            sheet.insertRule(`
                    input::placeholder, textarea::placeholder, .business-need-text {
                        font-size: 11.5px !important;
                    }
                `);
          } else if (window.innerWidth <= 770) {
            sheet.insertRule(`
                    input, textarea {
                        font-size: 12px !important;
                        padding: 12px 22px !important;
                    }
                `);
            sheet.insertRule(`
                    input::placeholder, textarea::placeholder, .business-need-text {
                        font-size: 12px !important;
                    }
                `);
          } else if (window.innerWidth <= 1410) {
            sheet.insertRule(`
                    input, textarea {
                        font-size: 12.5px !important;
                        padding: 12px 23px !important;
                    }
                `);
            sheet.insertRule(`
                    input::placeholder, textarea::placeholder, .business-need-text {
                        font-size: 12.5px !important;
                    }
                `);
          } else if (window.innerWidth <= 1920) {
            sheet.insertRule(`
                    input, textarea {
                        font-size: 13.5px !important;
                        padding: 12px 23px !important;
                    }
                `);
            sheet.insertRule(`
                    input::placeholder, textarea::placeholder, .business-need-text {
                        font-size: 13.5px !important;
                    }
                `);
          } else {
            sheet.insertRule(`
                    input, textarea {
                        font-size: 15px !important;
                        padding: 12.75px 25px !important;
                    }
                `);
            sheet.insertRule(`
                    input::placeholder, textarea::placeholder, .business-need-text {
                        font-size: 15px !important;
                    }
                `);
          }
          //input and textarea styling

          //submit button styling
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96 {
                            background: #030F46 !important;
                            font-family: stolzl, sans-serif !important;
                            font-weight: 300 !important;
                            font-style: normal !important;
                            color: white !important;
                            filter: unset !important;
                            transition: all 0.2s ease-in-out 0.01s !important;
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96:hover {
                            background: #ED1C24 !important;
                            color: white !important;
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96::after {
                            content: '';
                            display: inline-block;
                            width: 7px;
                            height: auto;
                            margin-left: 14px;
                            margin-top: .7px;
                            transition: all 0.2s ease-in-out 0.01s !important;
                            background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.04613 0.000234565L4.31523 3.50023L1.04613 6.99023L0.214844 6.10023L2.65266 3.49023L0.214844 0.890234L1.04613 0.000234565Z" fill="white"/></svg>') no-repeat center center;
                            background-size: contain;
                            vertical-align: middle;
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96:hover::after {
                            margin-left: 7px;
                            width: 4.5px;
                        }
                    `);
          if (window.innerWidth <= 470) {
            sheet.insertRule(`
                    button._formSubmitButton_cit2d_96 {
                        font-size: 11.5px !important;
                        padding: 13px !important;
                    }
                `);
          } else if (window.innerWidth <= 770) {
            sheet.insertRule(`
                    button._formSubmitButton_cit2d_96 {
                        font-size: 12px !important;
                        padding: 13px !important;
                    }
                `);
          } else if (window.innerWidth <= 1410) {
            sheet.insertRule(`
                    button._formSubmitButton_cit2d_96 {
                        font-size: 12.5px !important;
                        padding: 14px !important;
                    }
                `);
          } else if (window.innerWidth <= 1920) {
            sheet.insertRule(`
                    button._formSubmitButton_cit2d_96 {
                    font-size: 13.5px !important;
                    padding: 14.5px !important;
                    }
                `);
          } else {
            sheet.insertRule(`
                    button._formSubmitButton_cit2d_96 {
                    font-size: 15px !important;
                    }
                `);
          }
          //submit button styling

          //form disclaimer
          sheet.insertRule(`
                        ._formDisclaimer_cit2d_38 p {
                            color: #8187A2 !important;
                            font-family: stolzl, sans-serif !important;
                            font-weight: 300 !important;
                            font-style: normal !important;
                            text-transform: capitalize !important;
                            line-height: 1.65;
                            
                        }
                    `);
          if (window.innerWidth <= 470) {
            sheet.insertRule(`
                    ._formDisclaimer_cit2d_38 p {
                        font-size: 10px !important;
                        margin-bottom: 7px !important;
                    }
                `);
          } else if (window.innerWidth <= 1280) {
            sheet.insertRule(`
                    ._formDisclaimer_cit2d_38 p {
                        font-size: 11px !important;
                    }
                `);
          } else {
            sheet.insertRule(`
                    ._formDisclaimer_cit2d_38 p {
                        font-size: 12px !important;
                    }
                `);
          }
          sheet.insertRule(`
                        ._formDisclaimer_cit2d_38 p a{
                            color: #8187A2 !important;
                            font-weight: 300 !important;
                            text-decoration-thickness: .5px !important;
                            text-underline-offset: 2px !important;
                            transition: all 0.2s ease-in-out 0.01s !important;
                        }
                    `);
          sheet.insertRule(`
                        ._formDisclaimer_cit2d_38 p a:hover{
                            color: #ED1C24 !important;
                        }
                    `);
          //form disclaimer


          //form success
          sheet.insertRule(`
              section[data-testid="banner-success"] h2,
              section[data-testid="banner-success"] p{
                  display: block !important;
                  color: #030F46 !important;
                  text-align: left !important;
              }
          `);
          //form success

          // Add placeholders to inputs
          const inputs = shadow.querySelectorAll("input, textarea");
          inputs.forEach((input) => {
            const identifier = input.id || input.name; // fallback to name if no id
            switch (identifier) {
              case "first_name":
                input.placeholder = "first name*";
                break;
              case "last_name":
                input.placeholder = "last name*";
                break;
              case "email":
                input.placeholder = "email address*";
                break;
              case "custom#message":
                input.placeholder = "message*";
                break;
              default:
                break;
            }
          });

          // Apply the styles to the Shadow DOM
          shadow.adoptedStyleSheets.push(sheet);
          // Add a class to the form container for further customization
          formContainerContactPage.classList.add("loaded");
        }
      });

      // Observe for changes only within the custom section
      observer.observe(formContainerContactPage, {
        childList: true,
        subtree: true,
      });

      // Resize event listener to act like media query
      window.addEventListener("resize", () => {
        // Trigger MutationObserver actions based on screen size
        observer.takeRecords(); // Forces MutationObserver to re-evaluate
      });
    }
  }
  /// GENERAL FRAMING PAGE FORM STYLING ///

  /// TREEHIGGER FRAMING PAGE FORM STYLING ///
  if ($("body").hasClass("temp_name_treehugger-framing")) {
    const formContainerContactPage = document.querySelector(
      ".general_framing_page .hero_form_slider .form"
    );

    if (formContainerContactPage) {
      const observer = new MutationObserver((mutationsList, observer) => {
        const form = formContainerContactPage.querySelector("shopify-forms-embed");

        if (form) {
          observer.disconnect(); // Stop observing once the form is found
          const shadow = form.shadowRoot;

          const sheet = new CSSStyleSheet();

          //submit button styling
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96 {
                            background: #00A650 !important;
                        }
                    `);
          sheet.insertRule(`
                        button._formSubmitButton_cit2d_96:hover {
                            background: #030F46 !important;
                        }
                    `);
          //submit button styling

          // Apply the styles to the Shadow DOM
          shadow.adoptedStyleSheets.push(sheet);
          // Add a class to the form container for further customization
          formContainerContactPage.classList.add("loaded");
        }
      });

      // Observe for changes only within the custom section
      observer.observe(formContainerContactPage, {
        childList: true,
        subtree: true,
      });

      // Resize event listener to act like media query
      window.addEventListener("resize", () => {
        // Trigger MutationObserver actions based on screen size
        observer.takeRecords(); // Forces MutationObserver to re-evaluate
      });
    }
  }
  /// TREEHIGGER FRAMING PAGE FORM STYLING ///

  //////////////  CODE FOR SHOPIFY FORMS APP STYLING  //////////////

  //// HOME PAGE ////
  //test 2
  var $container = $(".home_page .sec_charity_auctions_outer .image_stack");
  var interval = 4000;

  function rotateSlides() {
    var $slides = $container.find(".image_wrapper");
    $slides.removeClass("active");

    // Move last slide to the front
    var $last = $slides.last();
    $last.prependTo($container);

    // Set active to new topmost (last in DOM)
    $container.find(".image_wrapper").last().addClass("active");
  }

  // Set the first one as active initially
  $container.find(".image_wrapper").last().addClass("active");
  // Auto rotate
  setInterval(rotateSlides, interval);
  //test 2

  // featured product slider //
  //   $(".featured_prd_slider").each(function () {
  //     const $inlineBtns = $(this).find(".inline_btns");
  //     const $buttons = $inlineBtns.find(".c_button");

  //     const $rightBtnsBlock = $(this).find(".btns_block");
  //     const $rightBtns = $rightBtnsBlock.find(".c_button");

  //     $buttons.removeClass("active in_active");
  //     $buttons.first().addClass("active");
  //     $buttons.not(":first").addClass("in_active");

  //     $rightBtns.removeClass("active in_active");
  //     $rightBtns.first().addClass("active");
  //     $rightBtns.not(":first").addClass("in_active");

  //     // Initialize first slider
  //     $(this).find(".slider_conteiner").hide().first().show();
  //     const $section = $(this).find(".slider_conteiner").first();
  //     const $prevArrow = $section.find(".arrow_container.prev");
  //     const $nextArrow = $section.find(".arrow_container.next");
  //     $(this).find(".slider_conteiner").first().find(".product-slider").slick({
  //       slidesToShow: 4,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       dots: false,
  //       infinite: false,
  //       prevArrow: $prevArrow,
  //       nextArrow: $nextArrow,
  //     });
  //   });

  //   $(".inline_btns").on("click", ".c_button", function () {
  //     const $btn = $(this);
  //     const $container = $btn.closest(".featured_prd_slider");
  //     const $buttons = $container.find(".inline_btns .c_button");
  //     const $activeBtn = $btn.attr("data-active");

  //     $buttons.removeClass("active").addClass("in_active");
  //     $btn.removeClass("in_active").addClass("active");

  //     $container.find(".btns_block .c_button").removeClass("active in_active");
  //     $container.find(".btns_block ." + $activeBtn).addClass("active");
  //     $container
  //       .find(".btns_block .c_button")
  //       .not("." + $activeBtn)
  //       .addClass("in_active");

  //     // Show corresponding slider container
  //     $container.find(".slider_conteiner").hide();
  //     const $activeSlider = $container.find("." + $activeBtn);
  //     $activeSlider.show();

  //     const $productSlider = $activeSlider.find(".product-slider");

  //     // Re-init slick: destroy and reinit
  //     if ($productSlider.hasClass("slick-initialized")) {
  //       $productSlider.slick("unslick");
  //     }

  //     const $prevArrow = $activeSlider.find(".arrow_container.prev");
  //     const $nextArrow = $activeSlider.find(".arrow_container.next");
  //     $productSlider.slick({
  //       slidesToShow: 4,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       dots: false,
  //       infinite: false,
  //       prevArrow: $prevArrow,
  //       nextArrow: $nextArrow,
  //     });
  //   });
  // featured product slider //
  //// HOME PAGE ////

  //// FAQs PAGE ////
  //FAQ DROPDOWN//
  $(".faqs_page .faq_block:first .question").addClass("current");
  $(".faqs_page .faq_block:first .question")
    .parent()
    .find(".answer")
    .slideDown();
  $(".faq_block .question").click(function () {
    if ($(this).hasClass("current")) {
      $(this).removeClass("current");
      $(this).parent().find(".answer").slideUp();
    } else {
      // // $(".faq_block .question").removeClass("current");
      // var active = $(this).attr("data-active");
      // // console.log("active: ", active);

      // $(".dropdown_g .image_g .child").removeClass("active");
      // $(".dropdown_g .image_g ." + active).addClass("active");
      // $(".faq_block .answer").slideUp();
      $(this).addClass("current");
      $(this).parent().find(".answer").slideDown();
    }
  });
  //FAQ DROPDOWN//
  //// FAQs PAGE ////

  //// PRODUCT PAGE ////
  //// signing product page ////
  // radio sleection //
  let triggered = false;
  const observer = new MutationObserver(function (mutations, obs) {
    if (triggered) return;

    const $radioList = $(".gs__radio-list");
    if ($radioList.length > 0) {
      $radioList
        .find(".gs__checkbox-container")
        .first()
        .find('input[type="radio"]')
        .trigger("click");
      triggered = true;
      obs.disconnect(); // Stop observing after first trigger
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  // radio sleection //

  // product sleection - addinfg class to add-on product //
  $(document).on(
    "click",
    ".gs__checkbox-label:not(.gs__rounded)",
    function (e) {
      // Prevent bubbling from the input
      if ($(e.target).is("input")) return;
      $(this).toggleClass("selecteddd");
      console.log("new");
    }
  );
  // product sleection //

  // error detection - checking if required add-ons are selected or not //
  //step 1 - helper function//
  function scrollToErrorElement() {
    const $errorEl = $(".gs__checkbox-label input.gs__input-error").first();
    // console.log("observer runned");

    if ($errorEl.length) {
      const elOffset = $errorEl.offset().top;
      const elHeight = $errorEl.outerHeight();
      const windowHeight = $(window).height();
      // console.log("observer runned if block");

      const scrollTo =
        elOffset - windowHeight / 2 + windowHeight * 0.1 + elHeight / 2;
      $("html, body").animate(
        {
          scrollTop: scrollTo,
        },
        600
      );
    }
  }
  //step 1 - helper function//

  //step 2 - click handler function//
  $(document).on("click", ".product-form__buttons", function (e) {
    if (!(e.originalEvent instanceof PointerEvent)) return;

    // console.log('product-form__buttons clicked');
    const errorObserver = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const target = mutation.target;
          if ($(target).hasClass("gs__input-error")) {
            scrollToErrorElement();
            break;
          }
        }

        if (mutation.type === "childList") {
          scrollToErrorElement();
          break;
        }
      }
    });

    errorObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    setTimeout(() => {
      errorObserver.disconnect();
      // console.log('observer disconnected after timeout');
    }, 1000);
  });
  //step 2 - click handler function//
  // error detection //

  // price change - diabling price and buy buttons
  const targetNode = document.body;

  // Observer to detect .priceee being added
  const priceeeObserver = new MutationObserver((mutationsList, observer) => {
    const priceee = document.querySelector(".priceee");
    const submitBtn = document.querySelector(".product-form__submit");
    const priceTotal = document.querySelector("[data-giftship-bundle-total]");

    if (priceee && submitBtn && priceTotal) {
      // Add classes initially
      priceee.classList.add("hidee");
      submitBtn.classList.add("disabllee");

      // Start observing price value changes
      const priceValueObserver = new MutationObserver(() => {
        const priceText = priceTotal.textContent.trim();

        if (priceText !== "$0.00") {
          priceee.classList.remove("hidee");
          submitBtn.classList.remove("disabllee");
        } else {
          priceee.classList.add("hidee");
          submitBtn.classList.add("disabllee");
        }
      });

      priceValueObserver.observe(priceTotal, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      observer.disconnect(); // Stop looking for .priceee once found
    }
  });

  priceeeObserver.observe(targetNode, {
    childList: true,
    subtree: true,
  });

  //btn disable click event
  if (document.body.classList.contains("temp_name_signing-product")) {
    document.addEventListener(
      "click",
      function (e) {
        const submitButton = document.querySelector(
          ".button.product-form__submit"
        );
        if (submitButton && submitButton.classList.contains("disabllee")) {
          if (submitButton.contains(e.target)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
          }
        }
      },
      true
    );
  }
  //btn disable click event
  // price change - diabling price and buy buttons

  //// signing product page ////

  //// main product page ////
  if (
    !$("body").hasClass("temp_name_signing-product") &&
    $("body").hasClass("temp_product")
  ) {
    $(".priceee").remove();

    //playing featured footage logic
    $(".view_footage_click").on("click", function (e) {
      e.preventDefault();

      const $videoWrapper = $(this).parent().find(".footage-video");
      const $videoTag = $videoWrapper.find("video");
      const $source = $videoTag.find("source").first();

      if ($source.length && $source.attr("src")) {
        const videoUrl = $source.attr("src");

        // Update href of Fancybox anchor
        const $fancyboxLink = $videoWrapper.find("a[data-fancybox]");
        $fancyboxLink.attr("href", videoUrl);

        // Manually trigger Fancybox
        $fancyboxLink.trigger("click");
      } else {
        console.warn("No video source found.");
      }
    });
    //playing featured footage logic
  }
  //// main product page ////
  //// PRODUCT PAGE ////

  //// COLLECTION PAGE ////
  //making drawer to comae above header
  $(document).on("click", ".mobile-facets__wrapper", function () {
    let $wrapper = $(".mobile-facets__disclosure");
    let $mainContent = $("#MainContent");

    // Give a slight delay to allow class toggling to apply before checking
    setTimeout(function () {
      if ($wrapper.hasClass("menu-opening")) {
        $mainContent.css("z-index", "100000");
      } else {
        $mainContent.css("z-index", "");
      }
    }, 25);
  });
  //making drawer to comae above header

  //hiding filter category section if options are 0
  $('.hide_featured_brand').each(function () {
    if ($(this).data('total-opts') === 0) {
      $(this).closest('details').hide();
    }
  });
  //hiding filter category section if options are 0

  //opening all filter section on desktop version
  $('#FacetsWrapperDesktop details').attr('open', true);
  //opening all filter section on desktop version
  //// COLLECTION PAGE ////



  //SIGNING PRODUCT PAGE//
  // Create observer
  const STOREFRONT_API_TOKEN = '282157dcce543067da23a160d9caf51c';
  const GRAPHQL_URL = '/api/2023-07/graphql.json';

  // Build GraphQL query for variant IDs to get parent product info
  function buildGraphQLQueryFromVariantIds(variantIds) {
    return `
      {
        nodes(ids: [${variantIds.map(id => `"gid://shopify/ProductVariant/${id}"`).join(',')}]) {
          ... on ProductVariant {
            id
            product {
              id
              title
              metafields(identifiers: [
                {namespace: "custom", key: "custom_description"}
              ]) {
                key
                value
              }
            }
          }
        }
      }
    `;
  }

  // Fetch product info from variant IDs
  function fetchProductsFromVariantIds(variantIds) {
    const query = buildGraphQLQueryFromVariantIds(variantIds);

    return fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN,
      },
      body: JSON.stringify({ query })
    })
    .then(res => res.json())
    .then(data => {
      if (!data.data || !data.data.nodes) return [];

      return data.data.nodes.map(node => {
        if (!node || !node.product) return null;

        const product = node.product;

        // ✅ Metafields may contain nulls → filter them out first
        const metafields = (product.metafields || []).filter(Boolean);

        // ✅ Now safely find the metafield
        const metafield = metafields.find(m => m.key === 'custom_description');

        return {
          variant_id: node.id,
          product_id: product.id,
          title: product.title,
          custom_description: metafield ? metafield.value : null
        };
      }).filter(Boolean);
    });
  }

  // Observe for #gsAppContainer
  const observer_signing = new MutationObserver(function () {
    if (document.body.classList.contains("temp_name_signing-product")) {
      const appContainer = document.getElementById("gsAppContainer");

      if (appContainer) {
        const checkboxes = appContainer.querySelectorAll(".gs__checkbox-container input[type='checkbox']");

        if (checkboxes.length > 0) {
          observer_signing.disconnect(); 

          // Loop through each checkbox container
          $(checkboxes).each(function () {
            console.log("Checkbox Value:", $(this).val());
          });
          // Collect variant IDs from checkboxes
          const variantIds = Array.from(checkboxes).map(input => input.value);

          // Fetch parent product info
          fetchProductsFromVariantIds(variantIds).then(products => {
            console.log("Fetched products info:", products);

            // const missing = variantIds.filter(id => 
            //   !products.some(p => p.variant_id.endsWith(id))
            // );
            // console.warn("Missing Variant IDs:", missing);            

            const $appContainer = $(appContainer); // wrap DOM element in jQuery

            $appContainer.find(".gs__checkbox-container").each(function () {
              const $container = $(this);
              const $input = $container.find("input[type='checkbox']");
              const variantId = $input.val();

              const productInfo = products.find(p => p.variant_id.endsWith(variantId));

              if (productInfo && productInfo.custom_description) {
                const $titleDiv = $container.find(".gs__checkbox-input-title");
                const $smallTag = $titleDiv.find("small");

                // Insert <p> above <small>, avoid duplication
                if ($titleDiv.find("p.custom_desc").length === 0) {
                  if ($smallTag.length > 0) {
                    $smallTag.before(`<span class="custom_desc">${productInfo.custom_description}</span>`);
                  } else {
                    $titleDiv.append(`<span class="custom_desc">${productInfo.custom_description}</span>`);
                  }
                }
              }
            });
          });
        }
      }
    }
  });

  // Start observing DOM changes
  observer_signing.observe(document.body, { childList: true, subtree: true });

  //SIGNING PRODUCT PAGE//


});
